import { Component, SVGProps } from 'react';
import SVG from '.';
interface SVGIconMinusProps extends SVGProps<any> {}
export class SVGIconMinus extends Component<SVGIconMinusProps> {
  render() {
    const { width = 20, height = 20, ...rest } = this.props;
    return (
      <SVG
        className="svg-icon-minus"
        width={`${width}`}
        height={`${height}`}
        viewBox={`0 -12 32 32`}
        {...rest}
      >
        <g
          id="Page-1"
          stroke="none"
          stroke-width="1"
          fill="none"
          fill-rule="evenodd"
        >
          <g
            id="Icon-Set-Filled"
            transform="translate(-414.000000, -1049.000000)"
            fill="#000000"
          >
            <path
              d="M442,1049 L418,1049 C415.791,1049 414,1050.79 414,1053 C414,1055.21 415.791,1057 418,1057 L442,1057 C444.209,1057 446,1055.21 446,1053 C446,1050.79 444.209,1049 442,1049"
              id="minus"
            ></path>
          </g>
        </g>
      </SVG>
    );
  }
}
